<template>
    <div class="margin-top-20">
        <div class="filter__section">
            <div class="row">
                <div class="col-md-6">
                    <!-- <div class="filter__title secondary-color-txt font-sanpro-semibold">Lớp</div> -->
                    <b-form-select v-model="paramQueryData.status" :options="listStatus">
                        <!-- <option value=0>Tất cả</option> -->
                    </b-form-select>
                </div>

            </div>
        </div>
        <div class="row mt-2" v-if="listDataAssign.length > 0">
            <div class="col-md-4" v-for="(item, index) of listDataAssign" :key="index">
                <ItemElectronicLecture @handelRecovery="handleRecovery" @handleEditDuration="handleEditDuration"
                    :item="item" :nameClass="nameClass" :type="1" />
            </div>
        </div>
        <div v-else class="text-center empty-data mt-3">
            Bài giảng điện tử đã giao chưa có dữ liệu
        </div>
        <div v-if="listDataAssign.length > 0" class="row pagination container m-0 mb-3">
            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
        </div>
        <ModalRecoveryAssign :dataLesson="dataLesson" :itemCurrentSelected="itemCurrentSelected"
            :type="paramQueryData.type" @closeModal="closeModalRecoveryAssign" @handelRecoveryDone="handelRecoveryDone"
            v-if="isOpenModalRecoveryAssign" />
        <ModalEditDuration @handleDone="handleDoneUpdateDuration" @closeModal="closeModalEditDuration"
            v-if="isOpenModalEditDuration" :type="paramQueryData.type" :item="itemCurrentSelected" />


    </div>
</template>
<script>
import moment from "moment"
import ModalRecoveryAssign from './ModalRecoveryAssign'
import { getListExcerciseTecherManager } from './../../_api/lessonClassSchoolUserServices';
import ModalEditDuration from './ModalEditDuration.vue'
import ItemElectronicLecture from './ItemElectronicLecture.vue'
export default {
    components: {
        ModalRecoveryAssign,
        ModalEditDuration,
        ItemElectronicLecture
    },
    props: {
        nameClass: {
            type: String,
            default: ''
        },
    },
    data() {
        return {

            listStatus: [
                { value: 0, text: 'Trạng thái - Tất cả' },
                { value: 1, text: 'Đã hoàn thành' },
                { value: 2, text: 'Đang giao' },
            ],
            paramQueryData: {
                type: 2,
                classSchoolId: 0,
                pageIndex: 1,
                pageSize: 6,
                status: 0,
            },
            listDataAssign: [],
            totalRecords: 0,
            isOpenModalRecoveryAssign: false,
            isOpenModalEditDuration: false,
            dataLesson: {
                id: 0,
                name: ''
            },
            itemCurrentSelected: {
                id: 0,
                listGroupId: '',
                name: '',
                classSchoolId: 0
            },

        }
    },
    watch: {
        'paramQueryData.status': 'getListData'
    },
    mounted() {
        this.paramQueryData.classSchoolId = this.$route.query.id
        this.getListData()
    },
    methods: {
        moment,
        handleDoneUpdateDuration() {
            this.paramQueryData.pageIndex = 1
            this.getListData()
            this.closeModalEditDuration()
        },
        handleOpenModalEditDuration() {
            this.isOpenModalEditDuration = true
        },
        closeModalEditDuration() {
            this.isOpenModalEditDuration = false
        },
        handleEditDuration(item) {
            this.itemCurrentSelected = {
                listAssignLessonId: item.listAssignLessonId,
                listGroupId: item.listGroupId,
                name: item.listClassGroupName,
                classSchoolId: item.classSchoolId,
                duration: item.duration,
            }
            console.log(this.itemCurrentSelected)
            this.isOpenModalEditDuration = true

        },
        handelRecoveryDone() {
            this.paramQueryData.pageIndex = 1
            this.getListData()
            this.closeModalRecoveryAssign()
        },
        closeModalRecoveryAssign() {
            this.isOpenModalRecoveryAssign = false
        },
        handleRecovery(item) {
            console.log(item)
            this.dataLesson = {
                id: item.id,
                name: item.name
            }
            this.itemCurrentSelected = {
                id: item.id,
                listGroupId: item.listGroupId,
                name: item.listClassGroupName,
                classSchoolId: item.classSchoolId
            }
            this.isOpenModalRecoveryAssign = true
        },
        getListData() {
            let self = this
            getListExcerciseTecherManager(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataAssign = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.recover-assign {
    color: #ff4f62;
    cursor: pointer;
}

.margin-top-20 {
    margin-top: 20px;
}

.margin-top-10 {
    margin-top: 10px;
}

.header-table .col-header {
    color: #94a3b0;
}

.icon-edit {
    width: 15px;
    cursor: pointer;
}
</style>